// ZUSTAND→ATOM off-ramp (docs/projects/complete/web/zustand-to-effect-atom-migration.md)
// Status: converted
// Ephemeral flow state on a keepAlive atom (shared across the setup islands).
import { useAtomSet, useAtomValue } from '@effect/atom-react';
import { Atom } from 'effect/reactivity';
import { useMemo } from 'react';

const postPurchaseStepAtom = Atom.make(0).pipe(Atom.keepAlive);

export function usePostPurchaseStep(): number {
  return useAtomValue(postPurchaseStepAtom);
}

export function usePostPurchaseActions() {
  const setStep = useAtomSet(postPurchaseStepAtom);
  return useMemo(
    () => ({
      nextStep: () => {
        setStep((step) => step + 1);
      },
      setStep: (step: number) => {
        setStep(step);
      },
    }),
    [setStep],
  );
}
